import React from 'react';
import BasePage from './BasePage';
import { Typography } from 'antd';

const { Title } = Typography;

const AccountManagementPage = () => {
    return (
        <BasePage>
            <div style={{ backgroundColor: '#FFF', padding: '20px', borderRadius: '4px' }}>
                <Title level={1}>Gerenciar Conta</Title>
                <p>Conteúdo da página de Gerenciamento de Conta será implementado aqui.</p>
            </div>
        </BasePage>
    );
};

export default AccountManagementPage;
